import { render, staticRenderFns } from "./RouteApproval.vue?vue&type=template&id=78e2368d&scoped=true&"
import script from "./RouteApproval.vue?vue&type=script&lang=js&"
export * from "./RouteApproval.vue?vue&type=script&lang=js&"
import style0 from "./RouteApproval.vue?vue&type=style&index=0&id=78e2368d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e2368d",
  null
  
)

export default component.exports